import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ProfileAccountComponent from './account.component';
import privacyComponent from './privacy/privacy.component';

const profileAccountModule = angular.module('tinaba.components.profile.account', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('profile.account', {
      url: '/account',
      template: '<profile-account></profile-account>'
    });
})

.component('profileAccount', ProfileAccountComponent)

.component('privacy', privacyComponent);

export default profileAccountModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/account/account.js
 **/